import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20abstract%20geometric%20composition%20with%20warm%20coral%20and%20terracotta%20gradients%20flowing%20organic%20shapes%20minimal%20elegant%20design%20with%20soft%20overlapping%20circles%20and%20waves%20sophisticated%20texture%20on%20light%20cream%20background&width=1600&height=900&seq=hero-bg-91&orientation=landscape"
        alt="91网 - 资源整合服务平台"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />
      <div className="relative z-10 w-full px-6 flex flex-col items-center text-center">
        <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 text-xs font-medium mb-6 border border-background-50/20">
          {siteInfo.tagline}
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 max-w-3xl leading-tight mb-6">
          汇聚全网优质资源<br />
          <span className="text-primary-400">一键直达所需服务</span>
        </h1>
        <p className="text-background-50/80 text-base md:text-lg max-w-2xl mb-10 leading-relaxed">
          500万+用户的信赖之选，30万+精选资源等你发现。无论设计素材、开发工具还是学习教程，91网助你高效获取。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/resource-navigation"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-all cursor-pointer"
          >
            探索资源
          </Link>
          <a
            href="#"
            className="px-8 py-3.5 rounded-full bg-background-50/15 text-background-50 border border-background-50/30 font-medium text-sm whitespace-nowrap hover:bg-background-50/25 transition-all cursor-pointer"
          >
            免费注册
          </a>
        </div>
        <div className="flex items-center gap-8 mt-12">
          {[
            { value: '500万+', label: '注册用户' },
            { value: '30万+', label: '精选资源' },
            { value: '50+', label: '资源分类' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">{stat.value}</p>
              <p className="text-xs text-background-50/60 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}